class ShapeLoader {
    // loads a binary particle cloud definition
    constructor(url) {
        return fetch(url)
            .then(data => data.arrayBuffer())
            .then(a => new Uint16Array(a));
    }
}

export default ShapeLoader;